import { render } from "./ArgonPaginationItem.vue?vue&type=template&id=5282bd26"
import script from "./ArgonPaginationItem.vue?vue&type=script&lang=js"
export * from "./ArgonPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__